import { render, staticRenderFns } from "./ShowEditVehicleModal.vue?vue&type=template&id=2c953f3a"
import script from "./ShowEditVehicleModal.vue?vue&type=script&lang=js"
export * from "./ShowEditVehicleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports